import { render, staticRenderFns } from "./LeavingAMessage.vue?vue&type=template&id=35d4b35c&scoped=true&lang=html&"
import script from "./LeavingAMessage.vue?vue&type=script&lang=js&"
export * from "./LeavingAMessage.vue?vue&type=script&lang=js&"
import style0 from "./LeavingAMessage.vue?vue&type=style&index=0&id=35d4b35c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d4b35c",
  null
  
)

export default component.exports